// [BD feat] Search drawer product carousel drag-scroll — bd-search-drawer.js
// The "Beliebte Produkte" carousel (sections/search-drawer.liquid) has no
// prev/next buttons — it's meant to scroll freely with the cursor on desktop,
// same as native touch scrolling does on mobile. theme.js's ScrollCarousel
// [allow-drag] mouse-drag path (assets/theme.js) was built for carousels that
// still have prev/next buttons: on mouseup it snaps/re-centers to the nearest
// cell via calculateLeftScroll_fn, which is what made the drawer's carousel
// jump straight to the last card instead of settling near where the cursor
// was released. sections/search-drawer.liquid deliberately does NOT set
// allow-drag any more (so theme.js's own mousedown listener never attaches),
// and this file replaces it with a plain 1:1 pan that stops wherever it's
// released and never calls scrollTo.
(function () {
  'use strict';

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var carousels = scope.querySelectorAll('.search-drawer__product-carousel');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      if (carousel.hasAttribute('data-bd-drag-init')) return;
      carousel.setAttribute('data-bd-drag-init', '');

      var dragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      function onMouseMove(event) {
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        carousel.scrollLeft = startScrollLeft - delta;
      }

      function onMouseUp() {
        carousel.classList.remove('is-dragging');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      carousel.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        dragged = false;
        startX = event.clientX;
        startScrollLeft = carousel.scrollLeft;
        carousel.classList.add('is-dragging');
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      // A drag that moved the cursor shouldn't also navigate to the product
      // the drag started on.
      carousel.addEventListener('click', function (event) {
        if (dragged) {
          event.preventDefault();
          dragged = false;
        }
      }, true);
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('.search-drawer__product-carousel')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Search drawer product carousel drag-scroll

// [BD feat] Clear search input on drawer close — bd-search-drawer.js
// x-drawer (assets/theme.js DialogElement) only clears its own open state on
// close — the query in #search-drawer-input and any rendered predictive
// results are left as-is, so reopening the drawer showed the previous
// search. Resetting #predictive-search-form on close clears the input and
// (via <predictive-search>'s own "reset" listener, assets/theme.js) reverts
// the results back to the placeholder slot, so every reopen starts fresh —
// same as if the drawer had never been searched in.
(function () {
  'use strict';

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var drawers = scope.querySelectorAll('#search-drawer');
    if (!drawers.length) return;

    drawers.forEach(function (drawer) {
      if (drawer.hasAttribute('data-bd-clear-init')) return;
      drawer.setAttribute('data-bd-clear-init', '');

      drawer.addEventListener('dialog:after-hide', function () {
        var form = document.getElementById('predictive-search-form');
        if (form) form.reset();
      });
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('#search-drawer')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Clear search input on drawer close
